<template>
  <section>
    <div>
      <div class="main-containers">
        <div class="columns">
          <div class="column">
            <h3>Vehículos Relacionados</h3>
          </div>
          <div>
            <vs-button
                icon="add"
                color="primary"
                type="filled"
                @click="openRegisterVehicle()"
                class="btn btn-primary">
              Agregar vehículo
            </vs-button>
          </div>
        </div>
        <hr/>
        <div>
          <div class=" is-justify-content-center card-container">
            <div class="new-card" v-for="vecicle in vehicleList">
              <div class="info-data active-line">
                <label class="status-person"> Activo </label>
              </div>
              <div>
                <div class="info-data active-column">
                  <div v-if="vecicle.photo.length == 0">
                    <vs-button
                        color="primary"
                        type="filled"
                        class="btn btn-primary btn-group-sm"
                        @click="$emit('openUpdatePhoto', {'codeVehicle' : vecicle.vehicle.code, 'action' : 'vehicle'} )">
                      Actualizar foto
                    </vs-button>

                  </div>
                  <img v-if="vecicle.photo.length > 0"
                      :src="photo + vecicle.photo"
                      alt="user"
                      class="rounded-circle"/>

                  <div class="info-data">
                    <h4>Tipo:<strong> {{ vecicle.vehicle.classification.title }}</strong></h4>
                    <h4>Marca: <strong>{{ vecicle.vehicle.brand }}</strong></h4>
                    <h4>Color: <strong> {{ vecicle.vehicle.color }}</strong></h4>
                    <h4>SN: <strong>{{ vecicle.vehicle.identification }}</strong></h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "ManagePerson",
  props: ['vehicleList'],
  data: () => ({
    title: "RecentMessages",
    photo:'/api/global/download-by-code/',
    codeVehicle : null,

  }),
  methods: {
    openRegisterVehicle() {
      this.$emit('openForm', "vehicle")
    }
  }
}
</script>

<style scoped>

.status-person {
  background-color: #44D600;
  border-radius: 6px 0px;
  width: 90px;
  font-style: normal;
  font-size: 14px;
  text-align: center;
  color: white;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
}

.new-card {
  width: calc(((100% + 20px) / 2) - 40px);
  margin-right: 20px;
  margin-top: 15px;
  border-radius: 6px;
  padding-bottom: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
}

.new-card:nth-child(2n) {
  margin-right: 0;
}

@media (max-width: 500px) {
  .card-container {
    flex-direction: column;
  }

  .new-card {
    width: 100%;
  }
}

.info-data {
  height: 50px;
  margin-left: 15px;
}

.info-data img {
  margin-left: 15px;
  width: 70px;
  height: 70px;
}

.info-data.active-column {
  display: flex;
  height: 70px;
  margin: 5px;
  justify-content: left;
}

.info-data.active-column h4 {
  margin: 2px;
  font-size: 15px;
}

.info-data.active-line {
  display: flex;
  margin: 0;
  height: 28px;

}
</style>


